import { Component } from "react";
import {connect} from 'react-redux';

class NeuroId extends Component {
  componentDidMount = () => {
    this.appendNeuroID()
  }

  appendNeuroID = () => {
    if (
      process.env.REACT_APP_PAYPAIR_ENV === "production" ||
      process.env.REACT_APP_PAYPAIR_ENV === "sandbox"
    )
    {
      const suffix = process.env.REACT_APP_PAYPAIR_ENV === 'sandbox' ? '-test' : '';
      // Multiple NeuroID site configs share the global `nid` queue and each
      // picks up every nid command (identify etc.): 'nid-atoms475' is ours
      // (used with Koalafi), 'nid-dares271' is AFF's, 'nid-purge571' is Uown's.
      const siteIds = ['nid-atoms475', 'nid-dares271', 'nid-purge571'];

      siteIds.forEach((siteId) => {
        const scriptUrl = `//scripts.neuro-id.com/c/${siteId}${suffix}.js`;

        const scriptContent = `
         (function(n,e,u,r,o,i,d){
          n.nid=n.nid||function(){(n.nid.q=n.nid.q||[]).push(arguments)};
          o=e.createElement(u);i=e.getElementsByTagName(u)[0];o.async=1;
          o.src=r;i.parentNode.insertBefore(o,i);
         })(window,document,'script', '${scriptUrl}');
        `;

        const scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.text = scriptContent;
        document.head.appendChild(scriptElement);
      });

      if (window.nid) {
        window.nid('setLinkedSiteId', 'form_kayak294');
        console.log('LinkedSiteId is set');
      }
    }
  }
  render() {
    return null;
  }
}

export default NeuroId;
